import React from 'react';
import { Link } from 'react-router-dom';

const Support = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm sticky top-0 z-50 backdrop-blur-sm bg-white/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="text-pink-400 font-bold text-4xl hover:text-pink-500 transition-colors">
            KinAlma
          </Link>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Support</h1>

          <div className="prose prose-lg max-w-none space-y-6 text-gray-700">
            <section className="mt-8 border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-semibold text-gray-900">Contact Us</h2>
              <p className="mt-4">
                If you need help or have any questions, please contact us at:{' '}
                <a href="mailto:accounts@kinalma.com" className="text-pink-600 hover:text-pink-700 transition-colors">
                  accounts@kinalma.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
